import React, { useEffect, useRef, useState } from 'react';
import "./styles.css";
import { SVGAsset } from 'res';
/**
 * @function UIEditTextInput 
 * @param {STRING} className - Additional CSS class that we can pass to the UIEditTextInput component.
 * @param {STRING} value - Pass the default value to the UIEditTextInput component.
 * @param {STRING} placeHolder - Pass the placeHolder value to the UIEditTextInput component.
 * @param {React.Component} children - React components that's being wrapped by the UIEditTextInput component.
 * @returns {React.Component}
 * @example
 * <UIEditTextInput className="some-class" value="Some value" placeHolder="Some value">
 *  <UIButton className="primary-button">Button name</UIButton>
 * </UIEditTextInput>
 */
export default function UIEditTextInput(props) {
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};
  const type = props.type ?? "text";
  const maxLength = props.maxLength ?? 999;
  const inputField = useRef();
  const ignoreToggle = { ignoretoggle : props.ignoreToggle ? "true" : "false" };
  const isEditing = String(props.isEditing) === "true";
  const allowEditing = String(props.allowEditing) === "true";
  const [ state, setState ] = useState({ value: props.value ?? "", edit: isEditing });
  const label = props.label ?? "";
  let changeLabel = `Change ${ label.toLowerCase() }`;
  if(label === "") changeLabel = "";
  let removeFormRowBottomMargin = state.value === "";

  if(props.removeBottomMargin === "true" || props.removeBottomMargin === true) {
    removeFormRowBottomMargin = true;
  } else if(props.removeBottomMargin === "false" || props.removeBottomMargin === false) {
    removeFormRowBottomMargin = false;
  }

  const formRowBottomMarginRemovedClass = removeFormRowBottomMargin ? "form-row-removed-bottom-margin" : "";

  const onChange = evt => {
    setState({ ...state, value: inputField.current.value });

    if(props.onChange instanceof Function) {
      props.onChange(inputField.current.value, evt, inputField.current);
    }
  };

  const onEditClick = () => setState({ ...state, edit: true });

  const editLink = (
    <a onClick={ onEditClick }>
        <span className="flex-container flex-horizontal align-center edit-link">
            <SVGAsset id="EditIcon" />
            <p>Edit</p>
        </span>
    </a>
  );

  useEffect(() => setState({ ...state, value: props.value ?? "" }), [ props.value ]);

  return(
    <div className={`form-row flex-height uitextinput edit ${ className } ${ formRowBottomMarginRemovedClass }`}>
      {/* Default state. */}
      { !state.edit &&
        <>
        { state.value === "" &&
          <div className="flex-container flex-horizontal">
              <div className="flex-width text-input-label">{ label }</div>
              { allowEditing && editLink }
          </div>
        }
        { state.value !== "" && 
          <>
            <div className="text-input-label">{ label }</div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width gray-text">{ state.value }</div>
                { allowEditing && editLink }
            </div>
          </>
        }
        </>
      }
      {/* Editing state. */}
      { state.edit && 
        <>
          { changeLabel !== "" && <div className="text-input-label">{ changeLabel }</div> }
          <div className="floating-label-input-container">
              <input className="floating-label-input form-row-input" maxLength={ maxLength } ref={ inputField }
              type={ type } placeholder=" " value={ state.value } onChange={ onChange } { ...dataPoint } { ...ignoreToggle }></input>
              <label className="floating-label form-row-label">{props.placeHolder}</label>
          </div>
          <span className="form-row-info-text gray-text">
              {props.children}
          </span>
        </>
      }
    </div>
  );
}